import { createSlice } from '@reduxjs/toolkit';
import {
	SustainabilityFormByAccessTokenDto,
	SustainabilityFormStatus
} from '../../models/sustainability';
import sustainabilityApi from '../apis/sustainability.api';

const initialState: {
	formByToken: SustainabilityFormByAccessTokenDto | null;
} = {
	formByToken: null
};

const sustainabilityApprovalSlice = createSlice({
	name: 'sustainabilityApproval',
	initialState,
	reducers: {
		setSustainabilityFormByToken(
			state,
			action: { payload: { token: string; form: SustainabilityFormByAccessTokenDto | null } }
		) {
			const { form } = action.payload;
			state.formByToken = form;
		}
	},
	extraReducers: (builder) => {
		const handleFulfilledByToken = (
			state: any,
			form: SustainabilityFormByAccessTokenDto | null
		) => {
			state.formByToken = form;
		};
		const handleRejectedForm = (state: any) => {
			if (!state.formByToken) {
				return;
			}
			state.formByToken.status = SustainabilityFormStatus.Rejected;
		};
		const handleApprovedForm = (state: any) => {
			if (!state.formByToken) {
				return;
			}
			state.formByToken.status = SustainabilityFormStatus.Approved;
		};

		builder
			.addMatcher(sustainabilityApi.endpoints.getFormFromToken.matchFulfilled, (state, action) =>
				handleFulfilledByToken(state, action.payload)
			)
			.addMatcher(sustainabilityApi.endpoints.rejectForm.matchFulfilled, (state) =>
				handleRejectedForm(state)
			)
			.addMatcher(sustainabilityApi.endpoints.approveForm.matchFulfilled, (state) =>
				handleApprovedForm(state)
			);
	}
});

export const { setSustainabilityFormByToken } = sustainabilityApprovalSlice.actions;

export default sustainabilityApprovalSlice.reducer;
